/* Everyday Garments theme scripts */
(function () {
  'use strict';

  var overlay = document.getElementById('PageOverlay');
  var menuDrawer = document.querySelector('[data-menu-drawer]');
  var cartDrawer = document.querySelector('[data-cart-drawer]');

  function openDrawer(drawer) {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.classList.add('is-active');
    document.body.classList.add('drawer-open');
  }

  function closeDrawers() {
    [menuDrawer, cartDrawer].forEach(function (d) {
      if (d) {
        d.classList.remove('is-open');
        d.setAttribute('aria-hidden', 'true');
      }
    });
    if (overlay) overlay.classList.remove('is-active');
    document.body.classList.remove('drawer-open');
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-open-menu]')) { e.preventDefault(); openDrawer(menuDrawer); }
    if (e.target.closest('[data-open-cart]')) { e.preventDefault(); openDrawer(cartDrawer); }
    if (e.target.closest('[data-close-menu]') || e.target.closest('[data-close-cart]')) { e.preventDefault(); closeDrawers(); }
  });
  if (overlay) overlay.addEventListener('click', closeDrawers);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawers(); });

  /* ------------------------------------------------------------
     Cart
     ------------------------------------------------------------ */
  function refreshCartDrawer(openAfter) {
    return fetch(window.location.pathname + '?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-cart-drawer]');
        if (fresh && cartDrawer) {
          cartDrawer.innerHTML = fresh.innerHTML;
        }
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        var count = document.getElementById('CartCount');
        if (count) {
          count.textContent = cart.item_count;
          count.classList.toggle('is-empty', cart.item_count === 0);
        }
        if (openAfter) openDrawer(cartDrawer);
      })
      .catch(function () {});
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    e.preventDefault();
    if (cartDrawer) cartDrawer.classList.add('is-loading');
    fetch(window.routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: Number(btn.dataset.line), quantity: Number(btn.dataset.qty) })
    })
      .then(function () { return refreshCartDrawer(false); })
      .then(function () { if (cartDrawer) cartDrawer.classList.remove('is-loading'); });
  });

  /* ------------------------------------------------------------
     Product form
     ------------------------------------------------------------ */
  var productForm = document.getElementById('ProductForm');
  if (productForm) {
    var variantsScript = document.querySelector('[data-variants-json]');
    var variants = variantsScript ? JSON.parse(variantsScript.textContent) : [];
    var selects = document.querySelectorAll('[data-option-select]');
    var idInput = document.getElementById('VariantId');
    var addButton = document.getElementById('AddToCart');
    var addLabel = addButton ? addButton.querySelector('[data-add-label]') : null;
    var priceWrap = document.getElementById('ProductPrice');

    function money(cents) {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP'
      }).format(cents / 100);
    }

    function currentVariant() {
      var chosen = Array.prototype.map.call(selects, function (s) { return s.value; });
      return variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === chosen[i]; });
      });
    }

    function updateVariant() {
      var variant = currentVariant();
      if (!variant) {
        if (addButton) { addButton.disabled = true; }
        if (addLabel) { addLabel.textContent = 'Unavailable'; }
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (addButton) addButton.disabled = !variant.available;
      if (addLabel) addLabel.textContent = variant.available ? 'Add to cart' : 'Sold out';
      if (priceWrap) {
        var html = '';
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          html = '<div class="price price--sale"><s class="price__compare">' + money(variant.compare_at_price) + '</s><span class="price__amount">' + money(variant.price) + '</span></div>';
        } else {
          html = '<div class="price"><span class="price__amount">' + money(variant.price) + '</span></div>';
        }
        priceWrap.innerHTML = html;
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    selects.forEach(function (s) { s.addEventListener('change', updateVariant); });

    var qtyInput = document.getElementById('Quantity');
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-qty-minus]') && qtyInput) {
        qtyInput.value = Math.max(1, Number(qtyInput.value) - 1);
      }
      if (e.target.closest('[data-qty-plus]') && qtyInput) {
        qtyInput.value = Number(qtyInput.value) + 1;
      }
    });

    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      if (addButton) addButton.disabled = true;
      if (addLabel) addLabel.textContent = 'Adding';
      fetch(window.routes.cart_add_url + '.js', {
        method: 'POST',
        body: new FormData(productForm)
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return refreshCartDrawer(true);
        })
        .then(function () {
          if (addLabel) addLabel.textContent = 'Add to cart';
          if (addButton) addButton.disabled = false;
        })
        .catch(function () {
          if (addLabel) addLabel.textContent = 'Add to cart';
          if (addButton) addButton.disabled = false;
          window.location.href = window.routes.cart_url;
        });
    });
  }

  /* ------------------------------------------------------------
     Countdown
     ------------------------------------------------------------ */
  document.querySelectorAll('[data-countdown]').forEach(function (el) {
    var raw = (el.dataset.date || '').trim();
    if (!raw) return;
    var normalised = raw.replace(/(\d{4})\s+(\d{2})\s+(\d{2})/, '$1-$2-$3').replace(' ', 'T');
    var target = new Date(normalised).getTime();
    if (isNaN(target)) return;

    var d = el.querySelector('[data-days]');
    var h = el.querySelector('[data-hours]');
    var m = el.querySelector('[data-minutes]');
    var s = el.querySelector('[data-seconds]');

    function pad(n) { return String(n).padStart(2, '0'); }

    function tick() {
      var diff = target - Date.now();
      if (diff <= 0) {
        if (d) d.textContent = '00';
        if (h) h.textContent = '00';
        if (m) m.textContent = '00';
        if (s) s.textContent = '00';
        clearInterval(timer);
        return;
      }
      if (d) d.textContent = pad(Math.floor(diff / 86400000));
      if (h) h.textContent = pad(Math.floor(diff / 3600000) % 24);
      if (m) m.textContent = pad(Math.floor(diff / 60000) % 60);
      if (s) s.textContent = pad(Math.floor(diff / 1000) % 60);
    }

    tick();
    var timer = setInterval(tick, 1000);
  });

  /* ------------------------------------------------------------
     Collection sort
     ------------------------------------------------------------ */
  var sortSelect = document.querySelector('[data-sort-select]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }
})();

/* Video sound toggle */
document.querySelectorAll('[data-video-sound]').forEach(function (btn) {
  var video = btn.closest('.video-block').querySelector('video');
  var on = btn.querySelector('[data-sound-on]');
  var off = btn.querySelector('[data-sound-off]');
  btn.addEventListener('click', function () {
    if (!video) return;
    video.muted = !video.muted;
    if (on) on.hidden = video.muted;
    if (off) off.hidden = !video.muted;
  });
});
